import React from "react";
import "./about.css";
import Me from "../../../res/avatars/8.png";
import { SlLayers } from "react-icons/sl";
import { SlBookOpen } from "react-icons/sl";
import { SlGraduation } from "react-icons/sl";



const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <img src={Me} alt="About me" className="about__me__img" />
        </div>

        <div className="about__content">
          <div className="about__cards">
            <a role={"button"} href="#experience">
              <article className="about__card">
                <SlLayers  className="about__icon" />
                <h5>Experience</h5>
                <div className="about__card_small">6+ years</div>
              </article>
            </a>
            <a role={"button"} href="#publications">
              <article className="about__card">
                <SlBookOpen className="about__icon" />
                <h5>Research Papers</h5>
                <div className="about__card_small">1</div>
              </article>
            </a>
            <a role={"button"} href="#education">
              <article className="about__card">
                <SlGraduation   className="about__icon" />
                <h5>Education</h5>
                <div className="about__card_small">BSc (Hons) in Information Technology at SLIIT</div>
              </article>
            </a>
          </div>

          {/* <div className="aboutparagraph">
            Hi,
            I am Praveen Premasinghe.<code className="about__highlights">  I am Front-End Developer & UI/UX Designer.</code> I have more than two years of experience as a
            Front-End Developer & UI/UX Designer specializing in creating user-friendly, responsive designs.
            I am confident that my skills and experience would be a valuable asset to your team.
I was responsible for developing and implementing the company’s website design and development.
I have a strong understanding of Front-end Development and am proficient in using <code className="about__highlights"> HTML 5, CSS, JavaScript 
and React JS</code>.also I have an understanding of UI/UX Designing using  <code className="about__highlights"> Figma and Adobe XD.</code>
          </div> */}


          <div className="aboutparagraph">
    Hey there, I'm <code className="about__highlights">Praveen Premasinghe</code>, a Software Engineer with a knack for <code className="about__highlights">front-end development and UI/UX design</code>. With over four years in the field, I've honed my skills to create sleek, user-friendly interfaces that seamlessly blend form and function.

    My journey in software engineering has seen me lead website design and development projects, where I've meticulously crafted code to bring ideas to life. Proficient in <code className="about__highlights">React JS,Type Script, HTML5,CSS,JavaScript.</code> I thrive on building robust, scalable solutions that stand the test of time.

    On the design front, I leverage tools like <code className="about__highlights">Figma and Adobe XD</code> to craft visually stunning interfaces that not only look good but also prioritize user experience. It's all about creating software that not only meets expectations but exceeds them, delighting users at every interaction.

    Let's collaborate and elevate your next project with my expertise in software engineering and design!
</div>

       
          
        </div>
      </div>
    </section>
  );
};

export default About;
